/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 阿拉伯语 国际化语言文件
 */
// 阿拉伯语.js
export default {
  centerAgent: {
    subagency: 'الوكالة الفرعية',
    search: 'بحث',
    subagencyIncome: 'دخل الوكالة الفرعية',
    last29Days: 'آخر 29 يوم',
    excludingToday: 'لا يشمل اليوم',
    commission: 'عمولة',
    last30Days: 'بيانات آخر 30 يوم',
    rank: 'التصنيف',
    hostNumber: 'عدد المضيفين',
    recent30Days: 'دخل المضيف خلال 30 يومًا الماضية',
    commissionRate: 'معدل العمولة',
    myCommission: 'عمولتي',
    remove: 'إزالة',
    thisAction: 'سيقوم هذا الإجراء بإزالة {hostoragent} {hostname} من فريقك. هل تؤكد المضي قدماً',
    dashboard: 'لوحة التحكم',
    information: 'معلومات',
    dataCenter: 'مركز البيانات',
    hostList: 'قائمة المضيفين',
    bdList: 'قائمة BD',
    agencyList: 'قائمة الوكالات',
    myRight: 'صلاحياتي',
    numberOf: 'عدد الوكالات',
    inviteAgency: 'دعوة وكيل',
    numberOfHost: 'عدد المضيفين',
    inviteHost: 'دعوة مضيف',
    inviteHostlinkcopied: 'تم نسخ رابط الدعوة',
    tipsShare: 'نصائح: شارك رابط الدعوة مع أصدقائك',
    thisMonthD: 'بيانات هذا الشهر',
    formDay1: 'من day1 إلى day2',
    hostGift: 'نقاط هدية المضيف',
    agentCommission: 'عمولة الوكيل',
    currentLevel: 'المستوى الحالي',
    commissionRateOf: 'معدل عمولة دخل الوكلاء',
    baseSalary: 'الراتب الأساسي',
    stillNeed: 'لا تزال بحاجة',
    toReach: 'للوصول',
    reachedthe: 'مهمة الإعلان',
    advertisementTask: 'نظرة عامة على البيانات',
    dataOverview: 'نظرة عامة على البيانات',
    today: 'اليوم',
    hostPoint: 'نقاط المضيف',
    agentsPoints: 'دخل نقاط الوكيل',
    thisMonth: 'هذا الشهر',
    month: 'شهر',
    lastMonth: 'الشهر الماضي',
    bdNumber: 'عدد BD',
    hostIncome: 'دخل المضيف',
    todayIncome: 'دخل اليوم',
    past30Days: 'آخر 30 يوم',
    host: 'مضيف',
    country: 'بلد',
    level7: 'المستوى / الإيرادات 7 أيام',
    pointIncome: 'دخل النقاط',
    liveDuration: 'مدة البث المباشر',
    joinTime: 'وقت الانضمام',
    state: 'الحالة',
    operation: 'عملية',
    bd: 'BD',
    totalHosts: 'إجمالي دخل المضيف',
    totalAgents: 'إجمالي دخل الوكيل',
    agent: 'الوكيل',
    agentLevel: 'مستوى الوكيل / معدل العمولة',
    commissionIncome: 'دخل العمولة',
    showDirect: 'إظهار الوكلاء المباشرين فقط. لا يشمل بيانات اليوم',
    excludingTodayData: 'لا يشمل بيانات اليوم',
    packages: 'الباقات',
    contents: 'المحتويات',
    balance: 'الرصيد',
    release: 'إصدار',
    issue: 'إصدار',
    createBd: 'إنشاء BD',
    times: 'مرة',
    authorizeCs: 'تفويض CS',
    giftTo: 'اهداء للمستخدم',
    bdCreation: 'المتبقي من حد إنشاء BD',
    csAuthorization: 'المتبقي من حصة تفويض CS',
    giftName: 'اسم الهدية',
    giftContents: 'محتوى الهدية',
    check: 'فحص',
    cancel: 'إلغاء',
    tip: 'إكرامية',
    recipientsVip: 'مستوى VIP للمستلم يتجاوز حد باقة الهدية. مزايا VIP من هذه الهدية سيتم تعطيلها. هل أنت متأكد من المتابعة؟',
    confirm: 'تأكيد',
    authorize: 'تفويض',
    inviteBy: 'دعوة بواسطة معرف المستخدم',
    invite: 'دعوة',
    inviteLink: 'رابط الدعوة',
    copy: 'نسخ',
    success: 'نجاح',
    pleaseCheck: 'يرجى التحقق من معرف المستخدم',
    totalGift: 'إجمالي دخل الهدايا لجميع المضيفين (باستثناء مكافآت المنصة مثل التصنيفات، المهام، إلخ)، يشمل دخل الهدايا للوكلاء التابعين.',
    totalAgentsCom: 'إجمالي عمولة الوكلاء من دخل مضيفيهم، بما في ذلك عمولة الوكلاء التابعين.',
    allAgent: 'جميع الوكلاء',
    directAgent: 'الوكلاء المباشرون',
    indirectAgent: 'الوكلاء غير المباشرين',
    newUpgraded: 'الوكلاء الجدد المُرقّون',
    newS: 'وكلاء جدد من المستوى S',
    newB: 'وكلاء جدد من المستوى B',
    newC: 'وكلاء جدد من المستوى C',
    expectedReward: 'المكافأة المتوقعة',
    newA: 'وكلاء جدد من المستوى A',
    agencyLevel: 'مستوى الوكالة',
    nickname: 'اللقب',
    upgradeDate: 'تاريخ الترقية',
    bdPolicy: 'سياسة BD',
    agencyDetail: 'تفاصيل الوكالة',
    agency: 'الوكالة',
    hostCommission: 'عمولة المضيف',
    last6Days: 'آخر 6 أيام',
    giftIncome: 'دخل الهدايا',
    mins: 'دقائق',
    agencyCenter: 'مركز الوكلاء',
    myIncome: 'دخلي اليوم',
    totalHost: 'إجمالي نقاط المضيف',
    overview: 'نظرة عامة',
    hostPoints: 'نقاط المضيف',
    myHosts: 'نقاط المضيف لدي',
    subagentHost: 'نقاط المضيف للوكلاء التابعين',
    subagencyNumber: 'عدد الوكالات التابعة',
    otherIncome: 'دخل آخر',
    contactAdmin: 'الاتصال بالمسؤول',
    whatsapp: 'واتساب',
    bdCenter: 'مركز BD',
    copySuccess: 'نسخ ناجح',
    pleaseInput: 'الرجاء إدخال مبلغ الشحن، الحد الأدنى 10',
    agencyPolicy: 'سياسة الوكالة',
    agencyCommission: 'عمولة الوكالة',
    agencyCommission2: 'عمولة الوكالة = معدل العمولة × إجمالي دخل الهدايا لجميع المضيفين (باستثناء مكافآت المنصة مثل التصنيفات، المهام، إلخ)',
    excludingPlatform: '(باستثناء مكافآت المنصة مثل التصنيفات، المهام، إلخ)',
    agencyCommissionCalculation: 'حساب عمولة الوكالة',
    level: 'مستوى',
    pointsTarget: 'الهدف النقاط (آخر 30 يوم)',
    points10000: '10,000 نقطة = 1 دولار أمريكي (M= مليون)',
    note1: 'ملاحظة 1: إجمالي الدخل الصالح = دخل وكالتك + دخل كل مستوى من الوكالات التابعة لك',
    note2: 'ملاحظة 2: سيتم إضافة عمولات الوكالة في الوقت الفعلي عندما يستلم المضيف هدية.',
    note3: 'ملاحظة 3: الحد الأدنى لمبلغ السحب هو 10 دولار أمريكي، ويجب أن تكون مبالغ السحب من مضاعفات العدد 10 (على سبيل المثال: 10 دولار، 20 دولار، 30 دولار).',
    subagencycommission: 'عمولة الوكالة التابعة',
    theMain: 'يمكن للوكالة الرئيسية كسب عمولات من دخل كل مستوى من الوكالات التابعة (T1, T2, T3, T4, ... Tn)، مع نسبة عمولة قصوى تبلغ 16%.',
    forExample: 'على سبيل المثال：',
    agencyA: 'الوكالة A تدعو الوكالة B والوكالة C.',
    agencyB: 'الوكالة B تدعو الوكالة D والوكالة E.',
    agencyC: 'الوكالة C تدعو الوكالة F.',
    noteFigures: '(ملاحظة: الأرقام بين القوسين تمثل دخل المضيفين تحت كل وكالة).',
    thusWe: 'وبالتالي، يمكننا حساب إجمالي الدخل الصالح ومعدل العمولة للوكلاء من الوكالة A إلى الوكالة F.',
    totalValid: 'إجمالي الدخل الصالح = دخل وكالتك + دخل كل مستوى من الوكالات التابعة',
    aTotal: 'إجمالي الدخل الصالح لـ A = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M (معدل عمولة 20%)',
    bTotal: 'إجمالي الدخل الصالح لـ B = B + D + E = 20M + 20M + 30M = 70M (معدل عمولة 16%)',
    cTotal: 'إجمالي الدخل الصالح لـ C = C + F = 70M + 80M =150M (معدل عمولة 20%)',
    dTotal: 'إجمالي الدخل الصالح لـ D =20M (معدل عمولة 12%)',
    eTotal: 'إجمالي الدخل الصالح لـ E =30M (معدل عمولة 12%)',
    fTotal: 'إجمالي الدخل الصالح لـ F =80M (معدل عمولة 16%)',
    subagencyCommission: 'عمولة الوكالة التابعة = (معدل عمولة الوكالة الرئيسية - معدل عمولة الوكالة التابعة) × إجمالي الدخل الصالح للوكالة التابعة',
    agencyAC: 'لجنة الوكالة {A} من الوكالة {B}',
    thereforeAgency: 'لذلك، إجمالي عمولة الوكالة {A} من الوكلاء التابعين',
    sinceAgency: 'نظرًا لأن الوكالات D وE وF ليس لديها وكلاء تابعين، فإنهم لا يستطيعون كسب عمولات من الوكلاء التابعين.',
    seniorPolicy: 'سياسة كبار',
    nomore: 'لا مزيد من البيانات',
    active: 'نشط',
    disabled: 'معطل',
    deleted: 'تم الحذف',
    lastLogintime: 'وقت آخر تسجيل دخول',
    onmic: 'على الميكروفون اليوم'
  },
  sellerCoin: {
    detailsOf: 'تفاصيل السحب',
    fundsSent: 'تم إرسال الأموال',
    transfer: 'تحويل',
    totalIncome: 'إجمالي الدخل',
    orderIncome: 'دخل الطلبات',
    estimatedReward: 'المكافأة المتوقعة',
    amount: 'المبلغ',
    applicantId: 'معرف مقدم الطلب',
    applicantName: 'اسم مقدم الطلب',
    orderId: 'معرف الطلب',
    uploadScreenshot: 'تحميل لقطة الشاشة',
    ensureWithdrawal: 'تأكد من نجاح السحب، ثم قم بتحميل لقطة الشاشة وانقر على الزر أدناه لإعلام مقدم الطلب.',
    remain: 'المتبقي',
    pleasePay: 'يرجى الدفع على الفور وتحميل الإيصال. إذا تجاوزت المهلة، سيتم إلغاء أهلية الدفع للطلب.',
    youCan: 'يمكنك كسب ما يصل إلى 5000 نقطة دعوة يوميًا',
    pleaseComplete: 'يرجى إكمال السحب في الوقت المناسب ',
    unableTo: 'غير قادر على الدفع، رفض',
    notifyThe: 'إعلام مقدم الطلب',
    youCanGet: 'يمكنك الحصول على مكافأة إضافية 1% - 3% إذا قمت بمعالجة الطلبات في الوقت المناسب.',
    ifYou: 'إذا قمت بمعالجة الطلبات خلال 30 دقيقة، يمكنك الحصول على مكافأة 3%.',
    egThe: 'على سبيل المثال: طلب بقيمة 90000 نقطة، قمت بمعالجته خلال 30 دقيقة، يمكنك الحصول على مكافأة 3%، أي 90000 × 3% = 2700 نقطة.',
    gotIt: 'فهمت',
    pleaseUpload: 'من فضلك حمّل الصورة',
    detail: 'التفاصيل',
    balance: 'Balance',
    exchange: 'تبادل',
    all: 'الكل',
    recharge: 'إعادة الشحن',
    official: 'رسمي',
    exchangeDetail: 'تفاصيل التبادل',
    coinSeller: 'بائع العملات',
    levelUp: 'ترقية المستوى',
    currentLevel: 'Current level',
    myBalance: 'رصيدي',
    details: 'التفاصيل',
    paymentMethod: 'طريقة الدفع',
    myOrder: 'طلبي',
    paymentMenthod: 'طريقة الدفع',
    acceptingOrders: 'قبول الطلبات',
    unavailable: 'غير متاح',
    greetingMessage: 'إعدادات رسالة الترحيب',
    serviceUnavailable: 'الخدمة غير متاحة',
    thisFeature: 'هذه الميزة مؤقتة مغلقة. يرجى الاتصال بدعم العملاء للحصول على المساعدة.',
    editMessage: 'تحرير الرسالة',
    customizeYour: 'قم بتخصيص رسالة الترحيب الخاصة بك. يمكنك تضمين معلومات مفيدة حول إعادة شحن العملات.',
    theMessage: 'سيتم إرسال الرسالة تلقائيًا عندما يبدأ مستخدم جديد محادثة خاصة معك',
    save: 'حفظ',
    pleaseEnterMessge: 'الرجاء إدخال رسالة الترحيب الخاصة بك',
    salesMethod: 'طريقة البيع',
    user: 'مستخدم',
    coinseller: 'بائع العملات',
    userId: 'معرف المستخدم',
    check: 'Check',
    coinAmount: 'مقدار العملة',
    pleaseEnter: 'الرجاء إدخال مضاعف 1',
    enterAt: 'أدخل 100 على الأقل، بمضاعفات 1',
    transferDetails: 'تفاصيل التحويل',
    recommendSeller: 'توصية البائع',
    recent30Day: 'مبيعات العملات خلال 30 يومًا الماضية',
    whatsapp: 'WhatsApp',
    chat: 'دردشة',
    yourCountry: 'بلدك لا يوجد به بائعي عملات متاحين حاليًا.',
    pleaseContact: 'يرجى الاتصال بدعم العملاء.',
    customerSupport: 'دعم العملاء',
    contact: 'اتصل',
    customRecharge: 'شحن مخصص',
    rechargeDetails: 'تفاصيل الشحن',
    myPoints: 'نقاطي',
    todayRemaining: 'الحصة المتبقية اليوم',
    customExchange: 'تبادل مخصص',
    exchangeDetails: 'تفاصيل التبادل',
    rechargeRules: 'قواعد الشحن',
    sellerLevel: 'مستوى البائع',
    proportion: 'نسبة',
    levelRequirement: 'متطلبات المستوى',
    beginner: 'مبتدئ',
    singleRecharge: 'شحن واحد',
    standard: 'قياسي',
    senior: 'كبار',
    exchangeRules: 'قواعد التبادل',
    note: 'Note',
    seniorCoin: 'بائع العملات الكبير يحصل على {point} نقاط مجانًا يوميًا. إضافي في ',
    beginnerSeller: 'بائع مبتدئ',
    standardSeller: 'بائع قياسي',
    seniorSeller: 'بائع كبير',
    cancel: 'Cancel',
    pleaseInput: 'Please input the recharge amount, minimum 10',
    pleaseInput2: 'الرجاء إدخال مبلغ الشحن، مضاعفات 100K',
    confirmation: 'تأكيد',
    userName: 'اسم المستخدم',
    theUser: 'تم إدراج المستخدم في القائمة السوداء',
    enterAmount: 'أدخل المبلغ',
    pleaseInput3: 'الرجاء إدخال المبلغ',
    theAmount: 'يجب أن يكون المبلغ مضاعفًا لـ 100000',
    pleaseInput4: 'الرجاء إدخال أو تحديد المبلغ',
    pleaseSelect: 'الرجاء تحديد طريقة البيع',
    pleaseInput5: 'الرجاء إدخال معرف المستخدم',
    atLeast: 'على الأقل 100K عملة للتحويل~',
    pleaseSelect2: 'الرجاء تحديد طريقة الدفع',
    minimum: 'الحد الأدنى',
    theAmount3: 'يجب أن يكون المبلغ مضاعفًا لـ 1',
    lessThan: 'أقل من أو يساوي 100000',
    orders: 'طلبات',
    applicant: 'مقدم الطلب',
    method: 'طريقة',
    withdrawTime: 'وقت السحب',
    viewDetail: 'عرض التفاصيل',
    toBe: 'في انتظار التأكيد',
    toBePaid: 'في انتظار الدفع',
    toBeCompleted: 'في انتظار الاكتمال',
    completed: 'مكتمل',
    abnormal: 'غير طبيعي',
    refused: 'Refused',
    confirmationTimeout: 'انتهت مهلة التأكيد',
    paymentTimeout: 'انتهت مهلة الدفع',
    binance: 'بينانس',
    scanThe: 'امسح رمز QR للدفع',
    quantity: 'كمية',
    orderAmount: 'مبلغ الطلب',
    date: 'تاريخ',
    payNow: 'ادفع الآن',
    payment: 'الدفع',
    pleasePay2: 'يرجى الدفع بالطريقة التالية',
    chainName: 'اسم السلسلة',
    contractAddress: 'عنوان العقد',
    theAbove: 'العنوان أعلاه صالح لهذا الشحن فقط',
    copy: 'Copy',
    notice: 'إشعار',
    pleaseTransfer: 'يرجى تحويل 1 USDT إضافي لتغطية رسوم Binance. قد يؤدي عدم القيام بذلك إلى تأخير شحن عملاتك.',
    paymentsMust: 'يجب إكمال المدفوعات خلال 0.5 ساعة، وإلا فلن تتحمل المنصة المسؤولية عن أي مشكلات.',
    add: 'إضافة',
    confirmTo: 'تأكيد حذف طريقة الدفع هذه',
    countryCurrency: 'الدولة ونوع العملة',
    selectPayment: 'حدد طريقة الدفع التي يمكنك إرسالها',
    coinsSeller: 'قواعد بائع العملات',
    standrd: 'قياسي',
    salesMethods: 'طرق البيع',
    coinsellerRules: 'قواعد بائع العملات',
    whenApplying: 'عند التقدم لترقية حالة بائع العملات، لا توجد متطلبات إيداع، تحتاج فقط إلى شحن لمرة واحدة لترقية مستوى بائع العملات. إذا اخترت الاستقالة من منصبك كبائع عملات، فإن دور بائع العملات الحالي الخاص بك سينتهي',
    youCanReplenish: 'يمكنك تجديد حسابك إما مباشرة باستخدام USDT أو Epay أو من خلال بائع عملات آخر',
    fraudulentActivities: 'الأنشطة الاحتيالية محظورة بشدة داخل منصة Hala.',
    anyViolations: 'أي انتهاكات ستؤدي إلى إنهاء حساب بائع العملات',
    allRights: 'جميع الحقوق محفوظة لـ Hala.',
    transferDetail: 'تفاصيل التحويل'
  },
  centerHost: {
    baseSalary: 'Base Salary',
    invitation: 'دعوة',
    tasks: 'مهام',
    other: 'أخرى',
    consume: 'استهلاك',
    giftIncome: 'Gift Income',
    received: 'تم الاستلام',
    from: 'من',
    luckyGift: 'هدية محظوظة',
    hostCenter: 'مركز المضيف',
    noAgent: 'لا وكيل',
    last7: 'آخر 7 أيام',
    hourlyIncome: 'الدخل بالساعة',
    toReach: 'to reach',
    rules: 'قواعد',
    pointsOverview: 'نظرة عامة على النقاط',
    totalIncome: 'Total Income',
    gifts: 'الهدايا',
    workDetail: 'تفاصيل العمل',
    liveDuration: 'Live Duration',
    mins: 'mins',
    todaysLive: 'سجل البث المباشر اليوم',
    dailyStatistics: 'الإحصائيات اليومية',
    startTime: 'وقت البدء',
    endTime: 'وقت الانتهاء',
    duration: 'المدة',
    points: 'نقاط',
    date: 'Date',
    giftPoints: 'نقاط الهدايا',
    removeBinding: 'إزالة الربط',
    thisAction2: 'هذا الإجراء سيفصلك عن {agentName}. يرجى التأكد إذا كنت ترغب في المتابعة مع فك الارتباط'
  },
  bombRule: {
    afterThe: 'بعد وصول قيمة التفجير في الغرفة إلى مبلغ معين، ستظهر قنبلة الهدية في الغرفة',
    oneCoins: '1 عملة مستلمة في الغرفة = 1 قيمة تفجير',
    itWill: 'ستنفجر تلقائيًا بعد تلبية المتطلبات، وسيتلقى مالك الغرفة مكافآت العملات الذهبية المقابلة'
  },
  descriptionLevel: {
    wealth: 'الثروة',
    charm: 'سحر',
    wealthValue: 'قيمة الثروة',
    charmValue: 'قيمة السحر',
    needTo: 'بحاجة إلى',
    send: 'إرسال',
    receive: 'استقبال',
    forThe: 'للترقية',
    theRich: 'يتم حساب مستوى الثراء بالعملات التي قمت بشحنها',
    theCharm: 'يتم حساب مستوى السحر بناءً على عدد العملات التي تتلقاها',
    LevelLabel: 'تسمية المستوى',
    level: 'Level',
    levelLogo: 'شعار المستوى'
  },
  gameRank: {
    gameRank: 'رتبة اللعبة',
    rules: 'Rules',
    thisWeek: 'هذا الأسبوع',
    lastWeek: 'الأسبوع الماضي',
    agentGaming: 'ترتيب إيرادات ألعاب الوكيل',
    rankingRewards: 'مكافآت التصنيف',
    rankingIs: 'يعتمد التصنيف على إجمالي حجم المراهنات للمستخدمين في غرفة الوكيل وغرفها الفرعية.',
    hostRoom: 'ترتيب إيرادات غرفة المضيف',
    rankingIs2: 'يعتمد التصنيف على إجمالي إيرادات الألعاب الناتجة في غرفة المضيف',
    notes: 'ملاحظات',
    eventDuration: 'مدة الحدث: كل أسبوع تقويمي. يتم توزيع المكافآت فقط إذا',
    rewardsAre: 'Rewards are distributed only if the corresponding revenue requirements are met.',
    allRewards: 'All rewards will be issued within 1-2 working days after the event ends.',
    halaReserves: 'تحتفظ Hala بالحق في التفسير النهائي لهذا الحدث',
    rewardsDetail: 'تفاصيل المكافآت',
    decorationsPreview: 'معاينة الديكورات'
  },
  gameLegacyHall: {
    surpriseLucky: 'حقيبة الحظ المفاجئة',
    dailyPlayers: 'يمكن للاعبين اليوميين فتح حقيبة الحظ في اليوم التالي للحصول على عملات عشوائية',
    eventRule: 'قاعدة الحدث',
    usersSpending: 'سيتم احتساب إنفاق المستخدمين في ألعاب الحدث نحو درجة تصنيفهم',
    thePlatform: 'ستدير المنصة ألعاب الحدث كل 4 ساعات، مع 4 ألعاب مختلفة في كل دورة',
    theTop: 'أفضل 3 لاعبين يوميين سيتلقون إطارات ومكافآت عملات',
    theTop2: 'أفضل 10 لاعبين أسبوعيين سيتلقون إطارات ومكافآت عملات',
    usersWho: 'يمكن للمستخدمين الذين يشاركون في ألعاب الحدث كل يوم فتح حقيبة حظ في اليوم التالي لتلقي مبلغ عشوائي من العملات. كلما أنفقت أكثر في ألعاب الحدث، قد تحصل على المزيد من العملات',
    behindPrevious: 'خلف السابق',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    countdown: 'العد التنازلي:',
    days: 'أيام',
    winOver: 'الفوز بأكثر من',
    coinsfrom: 'عملات من الألعاب في يوم واحد',
    earnOver: 'كسب أكثر من',
    coinsWitdh: 'بمعدل عائد يصل إلى',
    fromOneDay: 'من يوم واحد في',
    game: 'لعبة',
    fromA: 'من رهان واحد في',
    inthisWeek: 'في هذا الأسبوع',
    earnUp: 'اربح حتى',
    inAsingle: 'في يوم واحد',
    eventRules: 'قواعد الحدث',
    participateIn: 'شارك في اللعبة للمطالبة بحقيبة حظ أكبر غدًا',
    youDid: 'لم تتلق مكافأة العملة. شارك في اللعبة ويمكنك الاستمرار في المطالبة بحقيبة الحظ غدًا',
    participateIn2: 'شارك في اللعبة ويمكنك الاستمرار في المطالبة بحقيبة الحظ غدًا',
    topDaily: 'أفضل فائز يومي بالعملات',
    topPayout: 'أفضل فائز بمعدل العائد',
    topCoins: 'أفضل فائز بالعملات في جولة واحدة أسبوعيًا',
    topPayout2: 'أفضل فائز بمعدل العائد في جولة واحدة أسبوعيًا',
    topWeekly: 'أفضل فائز أسبوعي بالعملات',
    historicalTop: 'أفضل فائز تاريخي بالعملات في يوم واحد',
    historicalTop2: 'أفضل فائز تاريخي بمعدل العائد في يوم واحد',
    historicalTop3: 'أفضل فائز تاريخي بالعملات في جولة واحدة',
    historicalTop4: 'أفضل فائز تاريخي بمعدل العائد في جولة واحدة',
    historicalTop5: 'أفضل فائز تاريخي بالعملات في أسبوع واحد',
    gameReward: 'مكافأة اللعبة',
    usersSpending2: 'سيتم احتساب إنفاق المستخدمين في ألعاب الحدث نحو درجة تصنيفهم',
    theTop3: 'أفضل 3 لاعبين يوميين سيتلقون إطارات ومكافآت عملات',
    theTop4: 'أفضل 10 لاعبين أسبوعيين سيتلقون إطارات ومكافآت عملات',
    usersWho2: 'يمكن للمستخدمين الذين يشاركون في ألعاب الحدث كل يوم فتح حقيبة حظ في اليوم التالي لتلقي مبلغ عشوائي من العملات. كلما أنفقت أكثر في ألعاب الحدث، قد تحصل على المزيد من العملات',
    coins: 'عملات معدنية',
    flameRider: 'راكب النيران',
    sportCar: 'سيارة رياضية',
    captainMeow: 'كابتن مياو',
    profileFrame: 'إطار الملف الشخصي'
  },
  gold: {
    coinsDetail: 'تفاصيل العملات',
    coinBalance: 'رصيد العملات',
    all: 'ALL',
    sendGifts: 'إرسال الهدايا',
    purchaseItems: 'شراء العناصر',
    games: 'ألعاب',
    exchange: 'Exchange',
    recharge: 'Recharge',
    activeReword: 'مكافآت النشاط',
  },
  integral: {
    all: 'All',
    cashOut: 'سحب النقود',
    transfer: 'Transfer',
    orderId: 'Order ID',
    paymentMenthod: 'Payment Menthod',
    withdrawalTime: 'وقت السحب',
    pointsAmount: 'مقدار النقاط',
    depositAmount: 'مبلغ الإيداع',
    coinsAmount: 'مقدار العملات',
    transferTo: 'تحويل إلى',
    normal: 'عادي',
    pending: 'قيد الانتظار',
    success: 'Success',
    failed: 'فشل',
    points: 'Points',
    pointsBalance: 'رصيد النقاط',
    frozenPoints: 'النقاط المجمدة',
    details: 'Details',
    exchange: 'Exchange',
    currencyType: 'نوع العملة',
    paymentMethod: 'Payment method',
    pointsAmount2: 'مقدار النقاط للسحب النقدي',
    enterA: 'أدخل مضاعف 100,000 (الحد الأدنى 200,000)',
    enterA2: 'أدخل مضاعف 100000',
    accountInformation: 'معلومات الحساب',
    withdraw: 'سحب',
    amount: 'Amount',
    exchangeRate: 'سعر الصرف',
    exchangePoints: 'نقاط التبادل',
    enterUserId: 'أدخل معرف المستخدم',
    check: 'Check',
    fee: 'رسوم',
    theAgency: 'الوكالة ستحصل على',
    transferFee: 'رسوم التحويل: 2٪. الحد الأدنى للتحويل ≥ 100,000 نقطة.',
    clickTransfer: 'انقر فوق زر التحويل لتحويل النقاط المقابلة لوكلائك',
    afterThe2: 'بعد اكتمال التحويل، لا يمكن إلغاؤه أو سحبه',
    transferPoints: 'نقاط التحويل',
    recommendedMethod: 'الطريقة الموصى بها',
    lowerFees: 'رسوم أقل ومراجعة في غضون 24 ساعة',
    paymentPassword: 'كلمة مرور الدفع غير مضبوطة',
    cashOut2: 'السحب النقدي والتبادلات تتطلب التحقق من كلمة مرور الدفع. يرجى إعداد كلمة مرور الدفع أولاً.',
    cancel: 'Cancel',
    goTo: 'انتقل إلى الإعدادات',
    youHave: 'لقد بلغت 5 محاولات فاشلة. محاولة فاشلة أخرى ستؤدي إلى تجميد حسابك. إذا نسيت كلمة المرور الخاصة بك، يرجى إعادة تعيينها.',
    inputIncorrect: 'إدخال كلمة مرور غير صحيحة多次. تم تجميد حسابك، يرجى المحاولة مرة أخرى بعد',
    verify: 'تحقق',
    gotIt: 'Got it',
    pointsInfo: 'معلومات النقاط',
    whenA: 'عندما يرسل لك مستخدم هدايا باستخدام عملات تم شحنها عبر Google، فإن النقاط التي تستلمها سيتم تجميدها لمدة 7 أيام قبل أن تصبح متاحة. إذا طلب المستخدم استرداد الأموال، سيتم خصم هذه النقاط. يرجى اتباع قواعد المنصة وتجنب أي انتهاكات.',
    frozenPointsAre: 'النقاط المجمدة مدرجة في إجمالي رصيد النقاط',
    theUser2: 'تم إدراج المستخدم في القائمة السوداء',
    successfulWithdrawal: 'سحب ناجح',
    withdrawalAmount: 'مبلغ السحب',
    theFunds: 'ستصل الأموال خلال 24 ساعة',
    pleaseEnter2: 'الرجاء إدخال كلمة المرور',
    passwordIncorrect: 'كلمة المرور غير صحيحة',
    theAmount4: 'يجب أن يكون المبلغ مضاعفًا لـ 100000',
    pleaseEnter3: 'الرجاء إدخال معرف المستخدم',
    pleaseEnter4: 'الرجاء إدخال معرف المستخدم الصحيح',
    pleaseEnter5: 'الرجاء إدخال المبلغ',
    minimumTransfer: 'الحد الأدنى للتحويل ≥ 100,000 نقطة',
    pleaseSelect3: 'الرجاء تحديد الطريقة',
    minimum: 'minimum',
    theAmount5: 'يجب أن يكون المبلغ أقل من',
    illegalInput: 'إدخال غير قانوني',
    pleaseEnter6: 'الرجاء إدخال معلومات الحساب'
  },
  invite: {
    inviteGame: 'دعوة مستخدم اللعبة',
    currentRebate: 'الخصم الحالي',
    need: 'بحاجة إلى',
    toProgress: 'للتقدم إلى المستوى التالي',
    gameReward: 'Game Reward',
    referralData: 'بيانات الإحالة',
    referralList: 'قائمة الإحالة',
    date: 'Date',
    gameBets: 'مراهنات اللعبة',
    inviteRewards: 'مكافآت الدعوة',
    viewMore: 'عرض المزيد',
    inviteFriends: 'دعوة الأصدقاء',
    myReward: 'مكافأتي',
    totalRewards: 'إجمالي المكافآت',
    dailyReward: 'المكافأة اليومية',
    inviteRules: 'قواعد الدعوة',
    yourRebate: 'يعتمد معدل الخصم الخاص بك على إجمالي الرهانات الصالحة في آخر 30 يومًا',
    totalValid2: 'إجمالي الرهانات الصالحة = رهاناتك الخاصة + الرهانات الخاصة لكل مستوى من المستخدمين المدعوين',
    rebateFrom: 'الخصم من المستخدمين المدعوين من المستوى 1 = رهاناتهم الخاصة × معدل الخصم الخاص بك',
    rebateFrom2: 'الخصم من المستخدمين المدعوين من المستوى 2 = رهاناتهم الخاصة × (معدل الخصم الخاص بك - معدل خصم المستوى 1)',
    ifThe: 'إذا دعا المستخدم المدعو من المستوى 2 مستخدمًا من المستوى 3، فيمكن أن يزيد من إجمالي رهاناته الصالحة، لكنه لا يمكنه الحصول على خصم من المستوى 3.',
    example: 'مثال',
    tier1: 'المستوى 1 مدعو - كيف تحسب الخصم من أولئك الذين تمت دعوتهم مباشرة من قبلك؟',
    asRebate: 'خصم A من B و C و D = (رهانات B الخاصة + رهانات C الخاصة + رهانات D الخاصة) × معدل خصم A =',
    bsRebate: 'خصم B من E و F = (رهانات E الخاصة + رهانات F الخاصة) × معدل خصم B =',
    csRebate: 'خصم C من G = رهانات G الخاصة × معدل خصم C =',
    tier2: 'المستوى 2 مدعو - كيف تحسب الخصم من أولئك الذين تمت دعوتهم بشكل غير مباشر من قبلك؟',
    asRebate2: 'خصم A من E و F = (معدل خصم A - معدل خصم B) × (رهانات E الخاصة + رهانات F الخاصة) =',
    asRebate3: 'خصم A من G = (معدل خصم A - معدل خصم C) × رهانات G الخاصة =',
    myInvitation: 'دعوتي',
    search: 'Search',
    invitationTime: 'وقت الدعوة',
    inviteHost: 'Invite Host',
    inviteA: 'دعوة مضيف، كل واحد حتى',
    todayRewards: 'مكافآت اليوم',
    rewardDetail: 'تفاصيل المكافأة',
    creatorRewards: 'محفظة مكافآت المنشئ',
    collect: 'جمع',
    invitationDate: 'تاريخ الدعوة',
    hostPolicy: 'سياسة المضيف',
    halaReserves2: 'تحتفظ Hala بالحق في التفسير النهائي للسياسات المذكورة أعلاه.'
  },
  listContribution: {
    contributiont: 'مساهمة',
    host: 'Host',
    wealth: 'Wealth',
    today: 'Today',
    yesterday: 'أمس',
    game: 'Game',
    gift: 'هدية',
    hostEarnings: 'أرباح المضيف'
  },
  missionRule: {
    hostPolicy: 'Host Policy',
    halaReserves3: 'تحتفظ Hala بالحق في التفسير النهائي للسياسات المذكورة أعلاه'
  },
  purchase: {
    recharge: 'Recharge',
    userId: 'User ID',
    confirm: 'Confirm',
    switchAccount: 'تبديل الحساب',
    countryRegion: 'البلد/المنطقة',
    officialAgency: 'شحن الوكالة الرسمية',
    ttOff: 'خصم 20٪',
    totalAmount: 'المبلغ الإجمالي',
    purchase: 'شراء',
    pleaseComfirm: 'يرجى تأكيد معرف المستخدم',
    pleaseInput8: 'الرجاء إدخال معرف المستخدم',
    onlineService: 'خدمة عبر الإنترنت',
    dealOf: 'صفقة آخر 30 يومًا',
    recent30Day2: 'مبيعات العملات خلال 30 يومًا الماضية',
    paymentMethod: 'Payment Method',
    whatsapp: 'WhatsApp',
    chat: 'Chat',
    yourCountry2: 'بلدك لا يوجد به بائعي عملات متاحين حاليًا',
    pleaseContact2: 'يرجى الاتصال بدعم العملاء.',
    customerSupport: 'customer support',
    contact: 'Contact'
  },
  roomGiftRule: {
    eventRules: 'Event Rules',
    treasureChest: 'يتم زيادة تقدم صندوق الكنز عن طريق تقديم الهدايا في الغرفة',
    whenThe: 'عندما يمتلئ شريط التقدم لمفتاح الصندوق، سيتم فتح صندوق الكنز',
    afterThe3: '.بعد أن تفي صناديق الكنز من المستوى 3 والمستوى 4 بالمتطلبات، سيتم قفلها لمدة دقيقة واحدة ثم تفتح تلقائيًا',
    everyoneIn: 'لدى الجميع في الغرفة فرصة للحصول على المكافآت الموجودة في صندوق الكنز',
    onceThe: 'بمجرد فتح صندوق الكنز، قد يستغرق النظام بضع دقائق لإصدار المكافأة إلى حسابك. ستُضاف العملات الذهبية إلى رصيدك، وسيُضاف الزي إلى مخزونك.',
    theHigher: 'كلما ارتفع مستوى صندوق الكنز، كلما زادت المكافآت الموجودة فيه',
    ifYou2: 'إذا تم اختيارك كشخصية VIP بمستوى VIP أقل من مستواك الحالي، فلن يتم تطبيق مستوى VIP',
    theProgress: 'سيتم إعادة تعيين شريط تقدم مفتاح الصندوق في الساعة 00:00 (UTC+5:30) كل يوم'
  },
  share: {
    joinHala: 'انضم إلى هلا لفتح فرص متعددة للكسب والاستمتاع بمزايا ومكافآت مصممة خصيصًا للوكالات.',
    downloadTo: 'تنزيل لتصبح شريكًا',
    joinHala2: 'انضم إلى هلا للاستمتاع بالألعاب الممتعة وفرصة الفوز بجوائز مذهلة.',
    downloadAnd: 'قم بالتنزيل وابدأ بالفوز',
    joinHala3: 'انضم إلى هلا وابدأ رحلة الاستضافة. اربح مكافآت يومية تصل إلى ٣٦ دولارًا!',
    inviteYou: 'ندعوك للانضمام إلى الوكالة',
    downloadNow: 'قم بالتنزيل الآن لبدء الاستضافة',
    comeWith: 'تعال معي للانضمام إلى غرفة الدردشة في هلا',
    enthusiastsFrom: 'يتجمع المتحمسون من جميع أنحاء العالم للمشاركة...',
    igniteEndless: 'أشعل متعة لا نهاية لها',
    download: 'تحميل',
    halaLive: 'هلا لايف',
    showMe: 'أرني العالم سعيدًا',
    saySomething: 'قل شيئا...',
    downloadHala: 'تحميل تطبيق هلا'
  },
  starHost: {
    starHost: 'النجم المضيف',
    level2: 'المستوى {level} المحافظ عليه لمدة {days} أيام',
    currentSalary: 'الراتب الحالي',
    points: 'Points',
    likes: 'الإعجابات',
    stillNeed: 'Still need',
    done: 'منتهي',
    numberOf2: 'عدد مقدمي الهدايا',
    gifters: 'مقدمو الهدايا',
    gcoinGifts: 'هدايا Gcoin',
    gifts: 'gifts',
    liveDuration: 'Live Duration',
    min: 'دقيقة',
    completeAll: 'أكمل جميع المهام التالية للترقية',
    follower: 'متابع',
    numberOf3: 'عدد مقدمي الهدايا',
    daysAt: 'أيام في مستوى {level}',
    giftCollection: 'مجموعة الهدايا',
    gift: 'Gift',
    date: 'Date',
    expectedSalary: 'الراتب المتوقع',
    gcoin: 'جي كوين',
    status: 'حالة',
    levelReached: ' تم الوصول إلى المستوى',
    notAchieved: 'لم يتم تحقيقه',
    starHost2: 'قواعد استضافة النجوم',
    eachStar: 'يتمتع كل مضيف نجم بفترة تجريبية مدتها 3 أيام',
    theyWill: 'لن يصبحوا مضيفين رسميين إلا إذا استوفوا معايير المستوى A لجميع الأيام الثلاثة',
    thoseWho: 'سيتم فصل أولئك الذين يفشلون في تحقيق أهداف المستوى A اليومية',
    firedHosts: 'لا يمكن للمضيفين المفصولين الحصول على الراتب الأساسي للمضيف النجمي',
    starHost3: 'يتم دفع الراتب الأساسي لمضيف النجوم أسبوعيًا، كل يوم اثنين',
    ifA: 'إذا فشل مضيف النجوم في إكمال المهام اليومية، فسوف يتلقى 50٪ فقط من الراتب بالساعة',
    selfGifting: 'يُحظر تمامًا تقديم الهدايا الذاتية لجميع أهداف الهدايا',
    starHost4: 'مكافآت المضيف النجمي بمستويات مختلفة',
    level: 'Level',
    dailyExtra: 'مكافآت النقاط الإضافية اليومية',
    liveBroadcast: 'وقت البث المباشر المطلوب',
    starHost5: 'متطلبات المضيف النجمي للمستويات المختلفة',
    requirements: 'متطلبات)',
    yourApplication: 'تمت الموافقة على طلبك من قبل الجهة الرسمية',
    stayOn: 'البقاء في المستوى A لمدة 7 أيام',
    over1k: 'أكثر من 1000 معجب',
    totalGifter: 'إجمالي عدد مقدمي الهدايا > 300',
    receiveAll: 'احصل على جميع الهدايا "المحظوظة"',
    everyLucky: 'يجب أن يكون رقم كل هدية محظوظة أكبر من 100',
    stayOn2: 'البقاء في المستوى S لمدة 10 أيام',
    over2k: 'أكثر من 2 ألف معجب',
    totalGifter2: 'إجمالي عدد مقدمي الهدايا> 300',
    receiveAll2: 'احصل على جميع الهدايا "الساخنة"',
    stayOn3: 'البقاء على مستوى SS لمدة 10 أيام',
    over5k: 'أكثر من 5 آلاف معجب',
    totalGifter3: 'إجمالي عدد مقدمي الهدايا > 1000',
    receiveAll3: 'احصل على جميع الهدايا "الفاخرة"',
    starHost6: 'مهام ستار هوست اليومية',
    dailyAssessment: '(نظام التقييم اليومي): التفاعل / الهدايا',
    gcionGifts: 'هدايا جسيون',
    rulesTo: 'قواعد لتخفيض مستوى المضيف النجمي',
    failTo: 'الفشل في تلبية معايير المستوى الحالي لمدة 3 أيام متتالية.',
    failingTo: 'الفشل في تلبية المعايير <span>3 مرات خلال أسبوع',
    ifThe2: 'إذا فشل المضيف في استيفاء المتطلبات اليومية من المستوى A، فسيتم فصله مباشرةً بدلاً من تخفيض مستواه. بعد تخفيض مستواه، يجب عليه استيفاء معايير المستوى الأصلي لمدة 3 أيام متتالية لاستعادة مستواه السابق.',
    involvementIn: 'المشاركة في انتهاكات كبيرة أو حوادث سلبية.',
    causingDamage: 'التسبب في ضرر لمصالح المنصة أو صورة العلامة التجارية',
    applyFor: 'تقدم بطلب الإقلاع عن التدخين بنفسك',
    liveStreaming: 'متطلبات البث المباشر',
    liveStream: 'يجب أن يتوافق محتوى البث المباشر مع النوع المخصص للمضيف',
    roomHosts: 'يُمنع مضيفو الغرفة من كتم صوت الميكروفون الخاص بهم لفترات طويلة أثناء البث',
    liveStreams: 'يجب إجراء البث المباشر باستخدام تصميم غرفة الميكروفون المكونة من 9 مقاعد.',
    otherSeats: 'لا يُسمح للمستخدمين أو أعضاء الجمهور الذين يكتمون ميكروفوناتهم لأغراض إنجاز المهام بشغل المقاعد الأخرى في الغرفة.',
    discriminatoryInsulting: 'يُمنع منعًا باتًا التعليق التمييزي أو المهين أو المسيء في الغرفة'
  },
  starRoom: {
    afterCountdown: 'بعد العد التنازلي كل يوم، سيتم إدراج أفضل 3 غرف في تصنيف غرفة النجوم',
    top20Star: 'سيتم مكافأة الغرف ذات النجوم العشرين الأولى كمكافأة وفيرة بعد هذا الأسبوع',
    countdown: 'Countdown：',
    top3Daily: 'سيتم تأهيل أفضل 3 غرف يومية للانضمام إلى غرف النجوم الأسبوعية',
    starRooms: 'سيتم تصنيف غرف النجوم في آخر يوم من الأسبوع، بناءً على إجمالي العملات المتدفقة في كل غرفة.',
    top20Weekly: 'سيحصل أصحاب الغرف النجمية العشرون الأفضل أسبوعيًا على المكافآت على النحو التالي',
    qualificationTo: 'المؤهلات للمشاركة في هذا الحدث: لا يُسمح بأي انتهاكات أو سلوك غير قانوني في الغرفة، بمجرد العثور عليها، ستقوم هالة باستبعاد الغرفة وإزالتها من الرتبة',
    theRewards: 'سيتم إرسال المكافآت كل يوم اثنين.',
    days: 'days',
    coins: 'Coins'
  },
  inviteActive: {
    inviteHosts: 'دعوة المضيفين',
    pointsMax: '5000 نقطة كحد أقصى يوميًا',
    firstRecharge: 'مستخدمو إعادة الشحن الأولى',
    get20: 'احصل على 20 دولارًا مجانًا',
    oneInvite: '1. قم بدعوة المضيفين لبدء البث المباشر، عندما ينتهي المضيفون الذين قمت بدعوتهم من البث المباشر.',
    aFinish: 'أ. إكمال التحقق من الوجه في مركز المهام',
    bCreate: 'ب. إنشاء غرفتها الخاصة',
    cLive: 'ج. البث المباشر على الميكروفون لمدة 3 ساعات في غرفتها',
    dClaim: 'د. اطلب المكافآت المباشرة لأول مرة',
    youGet: 'ستحصل على نقاط مكافآت يوميًا من أرقام مستضيفيك المدعوين. يمكنك استلام المكافآت في اليوم التالي.',
    validHost: 'مضيف صالح',
    pointsReward: 'مكافأة النقاط',
    youCan: ' You can earn up to 5,000 invite points per day',
    myInvited: 'المضيفين المدعوين',
    validHosts: 'المضيفين الصالحين اليوم',
    pointsRewards: 'نقاط المكافآت',
    validHosts2: 'المضيفين الصالحين أمس:',
    claim: 'مطالبة',
    claimed: 'تم المطالبة به',
    completedTime: 'الوقت المكتمل',
    ifYour: 'إذا أنهى أصدقاؤك عملية إعادة الشحن الأولى، فستحصل على الكثير من المكافآت. (سيتم أيضًا تضمين إعادة الشحن دون اتصال بالإنترنت).',
    theMore: 'كلما زاد مبلغ الشحن الأول، كلما زاد عدد العملات التي ستحصل عليها، وقد يصل الأمر إلى 20 دولارًا يوميًا.',
    inviteesRecharge: 'المدعوون يعيدون شحن العملات المعدنية',
    yourReward: 'عملات المكافأة الخاصة بك',
    threeOnly: '3. سيتم احتساب المستخدمين الذين تمت دعوتهم لإعادة الشحن خلال 30 يومًا فقط كمستخدمين صالحين لإعادة الشحن لأول مرة.',
    seniorAnd: 'سيتم احتساب البائع الكبير والقياسي فقط عندما يقومون بإعادة الشحن من التطبيق أو المسؤول مباشرة (تعال إلى المشرف الخاص بك لمعرفة طرق الدفع) لأول مرة سيتم احتسابهم كمستخدمين صالحين لإعادة الشحن لأول مرة.',
    myInvited2: 'المستخدمون المدعوون',
    rechargeCoins: 'إعادة شحن العملات المعدنية',
    coinsRewards: 'مكافآت العملات المعدنية',
    firstRecharge2: 'عملات إعادة الشحن الأولى أمس:',
    firstRecharge3: 'عملات إعادة الشحن الأولى',
    firstRecharge4: 'وقت إعادة الشحن الأول'
  },
  hostPolicy: {
    title: 'سياسة المضيف',
    section1Title: 'الراتب الأساسي للأسبوع الأول للمضيفين الجدد',
    requirement: 'المتطلبات',
    newHostsDesc: 'المضيفون الجدد الذين انضموا إلى Hala في الأسبوع الأول',
    activeTime: 'الوقت النشط على الميكروفون',
    oneHour: 'ساعة واحدة',
    twoHour: 'ساعتان',
    threeHour: '3 ساعات',
    baseSalary: 'الراتب الأساسي (نقاط)',
    incomeRequirement: 'متطلبات الدخل',
    none: 'لا شيء',
    remarks: 'ملاحظات',
    remarksDesc: 'الحد الأقصى 3 ساعات/يوم. الحد الأقصى 7 أيام. الحد الأقصى الإجمالي للمكافأة 35,000 نقطة',
    note1: 'من تاريخ تسجيل المضيف، يبدأ العد التنازلي لفترة صلاحية الراتب الأساسي لمدة 7 أيام.',
    note2: 'سيتم حرمان المضيفين الذين يستخدمون حسابات متعددة أو يسجلون الدخول باستخدام عناوين IP أو أجهزة متعددة من مكافأة الراتب الأساسي.',
    note3: 'إذا كان دخل المضيف في آخر 7 أيام يزيد عن 150,000 نقطة، ستحصل على مكافأة المضيف العادي بالساعة بدلاً من مكافأة الراتب الأساسي للمضيف الجديد.',
    section2Title: 'مكافأة المضيف العادي المتساوية',
    level: 'المستوى',
    incomeRequirementShort: 'متطلبات الدخل',
    hourlyReward: 'المكافأة بالساعة',
    maximumDailyHours: 'الحد الأقصى للساعات اليومية',
    section2Note1: 'يتم احتساب 15 دقيقة متتالية على الميكروفون كوقت فعال.',
    section2Note2: 'يتم تسوية جميع المكافآت بالنقاط ويجب المطالبة بها في نظام المهام.',
    section2Note3: 'لن يتم احتساب مكافآت المنصة في متطلبات النقاط.',
    section2Note4: 'سيتم خصم النقاط بمجرد اكتشاف عناوين IP أو أجهزة متعددة.',
    section2Note5: 'آخر 7 أيام تعني آخر 6 أيام + اليوم، لذا قد تزداد مكافآتك الساعية كلما وصلت إلى مستوى نقاط أعلى في الوقت المناسب.',
    section2Note6: 'مكافآت المستوى L غير المستهدفة ستكون صالحة فقط خلال أول 7 أيام بعد التسجيل. بعد 7 أيام، يمكن للمضيفين الحصول على 500 نقطة مجانية يوميًا بشكل دائم.',
    section3Title: 'لوائح المضيف',
    regulation1: 'يُمنع على المضيفين تسجيل حسابات متعددة.',
    regulation2: 'يُمنع الترويج لمنصات الطرف الثالث.',
    regulation3: 'يُمنع القصر تمامًا.',
    regulation4: 'لا يمكن للمضيف سوى الحصول على معرف واحد موثق. فقط المعرفات الموثقة يمكنها بدء البث المباشر وسحف الأرباح.',
    regulation5: 'يتم حظر أي عمل من انتحال المصادقة الوجهية لبدء البث المباشر أو سحف الأرباح بشكل دائم.',
    regulation6: 'تقديم المعرف للآخرين للبث المباشر سيؤدي إلى حظر المعرف بشكل دائم من قبل النظام.',
    regulation7: 'في غرفة الصوت، يجب على المضيفين تحية المستخدمين الذين يدخلون الغرفة بنشاط.',
    regulation8: 'يجب أن تستخدم صورة غرفة الصوت صورة حقيقية ومتوافقة للمضيف.',
    regulation9: 'منصة Hala تحظر بصرامة أي أنشطة احتيالية. أي انتهاك س يؤدي إلى تعليق الحساب بشكل دائم.',
    footer: 'تحتفظ Hala بالحق في التفسير النهائي للسياسات المذكورة أعلاه.',
  },
  correspondingRevenue: 'تم استيفاء متطلبات الإيرادات المقابلة. سيتم إصدار جميع المكافآت',
  within12: 'خلال 1-2 يوم عمل بعد انتهاء الحدث'
}
